import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	locationUpdateResponse: {},
	scannedItems: [],
	scannedSampleIds: [],
	selectedProductIds: [],
	searchValue: '',
	isUndo: false,
	locationResponseFromLocationScan: {},
	rowQrCode: '',
	isCycleStart: false,
	isLocationScannedBefore: false
};

export const scanSlice = createSlice({
	name: 'scan',
	initialState,
	reducers: {
		setLocationUpdateResponse: (state, { payload }) => {
			state.locationUpdateResponse = payload;
		},
		setScannedItems: (state, { payload }) => {
			const sortedScannedItems = [...payload];
			state.scannedItems = sortedScannedItems;
		},
		setScannedSampleIds: (state, { payload }) => {
			state.scannedSampleIds = Array.isArray(payload) ? [...new Set(payload)] : payload;
		},
		setSelectedProductIds: (state, { payload }) => {
			state.selectedProductIds = Array.isArray(payload) ? [...new Set(payload)] : payload;
		},
		setSearchValue: (state, { payload }) => {
			state.searchValue = payload;
		},
		setIsUndo: (state, { payload }) => {
			state.isUndo = payload;
		},
		setRowQrCode: (state, { payload }) => {
			state.rowQrCode = payload;
		},
		setLocationResponseFromLocationScan: (state, { payload }) => {
			state.locationResponseFromLocationScan = payload;
		},
		setIsCycleStart: (state, { payload }) => {
			state.isCycleStart = payload;
		},
		setIsLocationScannedBefore: (state, { payload }) => {
			state.isLocationScannedBefore = payload;
		},
		resetScanStore: () => {
			return initialState;
		},
		resetScannedItems: (state) => {
			state.scannedItems = [];
			state.selectedProductIds = [];
			state.scannedSampleIds = [];
		}
	}
});

export const {
	setLocationUpdateResponse,
	setScannedItems,
	setScannedSampleIds,
	setSelectedProductIds,
	setSearchValue,
	setIsUndo,
	setRowQrCode,
	setLocationResponseFromLocationScan,
	setIsCycleStart,
	setIsLocationScannedBefore,
	resetScanStore,
	resetScannedItems
} = scanSlice.actions;

export default scanSlice.reducer;
